import FormPauseSessions from '../contact/FormPauseSessions/FormPauseSessions';

export const PauseEnrolment = () => {
  return <FormPauseSessions />;
};
